module.exports = __webpack_public_path__ + "static/optiwe_gvamax-09f07b59f94932a0075a950f24ccb11d.jpg";